var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Model, Watch } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import { Teacher } from '@/models/Teacher';
import DataTable from '@/components/data-table/DataTable';
import { Group as GroupModel } from '@/models/Group';
import PageHeader from '@/components/page-header/PageHeader';
import AddUserDialog from '@/views/Groups/AddUserDialog';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { excludeRoles } from '@/support/ExcludeRoles';
import { TabsColorEnum } from '@/config/theme';
import { RolesEnum } from '@/items/Roles';
import { GroupTypeEnum } from '@/models/GroupType';
import { GroupIncludes } from '@/models/Model';
import ErrorHandler from '@/support/ErrorHandler';
import GroupNotesDialog from '@/components/GroupNotesDialog/GroupNotesDialog';
let Group = class Group extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Group';
        this.activeTab = '';
        this.group = null;
        this.isGroupNotesDialogOpen = false;
        this.users = [];
        this.RolesEnum = RolesEnum;
    }
    get breadcrumbs() {
        const groupName = this.group && this.group.name ? this.group.name : '';
        return [{ name: 'Groups', path: '/groups' }, { name: groupName ? groupName.toString() : '', path: this.$route.path }];
    }
    get user() {
        return this.$store.state.Auth;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolGroups.navigationItems.messenger.includes(this.$store.state.Auth.roles[0].id);
    }
    get tabs() {
        return [
            {
                description: 'string',
                icon: 'home',
                is_visible: true,
                label: 'HOME',
                to: `/groups/${this.group ? this.group.id : ''}`,
            },
            {
                color: TabsColorEnum.LIGHT_BLUE,
                description: `${this.$tc('navigationCard.group.profile')}`,
                icon: 'face',
                is_visible: true,
                label: this.$tc('navigationCard.group.titles.profile'),
                to: `/groups/${this.group ? this.group.id : ''}/profile`,
            },
            {
                color: TabsColorEnum.RED,
                description: `${this.$tc('navigationCard.group.files')}`,
                icon: 'article',
                is_visible: !!(this.group && this.group.type && typeof this.group.type !== 'string' && this.group.type.label === 'project'),
                label: this.$tc('subject.tab.files'),
                to: `/groups/${this.group ? this.group.id : ''}/files`,
            },
            {
                color: TabsColorEnum.PINK,
                description: `${this.$tc('navigationCard.group.steps')}`,
                icon: 'low_priority',
                is_visible: !!(this.group && this.group.type && typeof this.group.type !== 'string' && this.group.type.label === 'project'),
                label: this.$tc('steps.title'),
                to: `/groups/${this.group ? this.group.id : ''}/steps`,
            },
            {
                color: TabsColorEnum.PURPLE,
                description: `${this.$tc('navigationCard.group.messages')}`,
                icon: 'question_answer',
                is_visible: !this.exclude && !this.isParnassysGroup,
                label: this.$tc('navigationCard.group.titles.messages'),
                to: `/groups/${this.group ? this.group.id : ''}/messages`,
            },
            {
                color: TabsColorEnum.YELLOW,
                description: `${this.$tc('navigationCard.group.notes')}`,
                icon: 'sticky_note_2',
                is_visible: this.user.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT]) && !this.isParnassysGroup,
                label: this.$tc('navigationCard.group.titles.notes'),
                to: `/groups/${this.group ? this.group.id : ''}/notes`,
            },
            {
                color: TabsColorEnum.GREY,
                description: `${this.$tc('navigationCard.group.audit')}`,
                icon: 'approval',
                is_visible: this.user.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER]) && !this.isParnassysGroup,
                label: 'GroepsAudit',
                to: `/groups/${this.group ? this.group.id : ''}/audit`,
            },
            {
                color: TabsColorEnum.DARK_GREEN,
                description: `${this.$tc('navigationCard.group.studentOverview')}`,
                icon: 'area_chart',
                is_visible: this.user.hasRole([
                    RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.RESELLER, RolesEnum.TEACHER,
                ]),
                label: this.$tc('navigationCard.group.titles.studentOverview'),
                to: `/groups/${this.group ? this.group.id : ''}/student-overview`,
            },
            {
                color: TabsColorEnum.ORANGE,
                description: `${this.$tc('navigationCard.group.curriculum')}`,
                icon: 'dynamic_feed',
                is_visible: this.user.hasRole([
                    RolesEnum.ROOT,
                    RolesEnum.ADMIN,
                    RolesEnum.BOARD,
                    RolesEnum.TEACHER,
                ]),
                label: this.$tc('navigationCard.group.titles.curriculum'),
                to: `/groups/${this.group ? this.group.id : ''}/curriculum`,
            },
            {
                color: TabsColorEnum.BLUE,
                description: this.$tc('navigationCard.student.plan_group', 1),
                icon: 'receipt_long',
                label: this.$tc('student_plan.title_group', 1),
                is_visible: !this.isParnassysGroup,
                to: `/groups/${this.group ? this.group.id : ''}/plan`,
            },
            {
                color: TabsColorEnum.LIGHT_GREEN,
                description: `${this.$tc('navigationCard.group.projectPlan')}`,
                icon: 'collections_bookmark',
                is_visible: !this.isParnassysGroup,
                label: this.$tc('navigationCard.group.titles.plan'),
                to: `/groups/${this.group ? this.group.id : ''}/projectplan`,
            },
            {
                color: TabsColorEnum.PINK,
                description: `${this.$tc('navigationCard.group.report')}`,
                icon: 'description',
                is_visible: this.user.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT]) && !this.isParnassysGroup,
                label: this.$tc('navigationCard.group.titles.report'),
                to: `/groups/${this.group ? this.group.id : ''}/report`,
            },
        ];
    }
    mounted() {
        // this.initialize();
    }
    initialize() {
        new GroupModel()
            .include([GroupIncludes.AUDIT, GroupIncludes.CHAT, GroupIncludes.USERS, GroupIncludes.SUBJECTS, GroupIncludes.ROLES, GroupIncludes.PARENT, GroupIncludes.NOTES, GroupIncludes.PROJECTS, GroupIncludes.TYPE, GroupIncludes.SUB_GROUPS, GroupIncludes.LEVEL])
            .find(this.$route.params.id)
            .then((group) => {
            if (group.subjects) {
                group.subjects = new GroupModel().dataToModel({}, 'Subject', group.subjects);
            }
            this.group = group;
            group.users.forEach((user) => {
                if (user.id) {
                    this.users.push(user.id);
                }
            });
        })
            .catch((error) => {
            ErrorHandler.network(error);
            console.error('error GroupModel', error && error.response && error.response.data ? error.response.data : error);
        });
    }
    tabStyle(tab) {
        if (!tab) {
            return;
        }
        if (!tab.color) {
            return;
        }
        if (this.isActiveTab(tab)) {
            return {
                backgroundColor: tab.color,
            };
        }
        return {
            borderBottom: `4px solid ${tab.color}`,
        };
    }
    sync(group) {
        this.group = group;
    }
    isActiveTab(tab) {
        if (!tab || !tab.to) {
            return false;
        }
        if (this.$route.path
            && this.$route.path.includes('/subject')
            && tab.to.includes('/curriculum')) {
            return true;
        }
        return this.activeTab === tab.to;
    }
    onMouseOver(event, tab) {
        document.documentElement.style
            .setProperty('--hover-color', tab.color || 'transparent');
    }
    get isParnassysGroup() {
        return !!(this.group && this.group.type && typeof this.group.type !== 'string' && this.group.type.label === GroupTypeEnum.PARNASSYS);
    }
    onRouteChanged() {
        this.initialize();
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Group.prototype, "student", void 0);
__decorate([
    Model('teacher', { default: () => new Teacher() }),
    __metadata("design:type", typeof (_b = typeof Teacher !== "undefined" && Teacher) === "function" ? _b : Object)
], Group.prototype, "teacher", void 0);
__decorate([
    Watch('$route.params.id', { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Group.prototype, "onRouteChanged", null);
Group = __decorate([
    Component({
        components: {
            PageHeader,
            DataTable,
            AddUserDialog,
            SelectFilter,
            GroupNotesDialog
        },
    })
], Group);
export default Group;
